import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Wallop Studio',
    description: 'Independent Brooklyn studio building bold brand identities, scroll-stopping packaging and photoreal 3D product renders for consumer brands.',
    url: getOrigin(),
    ogImage: 'https://wallop-studio.cdn.modulify.website/share/wallop-studio-og.jpg'
}

// Storage key of the social share image. The home page builds its address from the
// site's current storage host at build time and falls back to `siteConfig.ogImage`.
export const SHARE_IMAGE_KEY = 'share/wallop-studio-og.jpg'
